export const gsmRedColor = 'rgb(234,0,0)';
export const gsmBlackColor = 'rgb(48,48,48)';

export const gsmWhiteColor = 'rgb(255,255,255)';
export const gsmGreyColor = '#c1c1c1';
export const gsmBgGreyColor = '#F5F5F5';